import { Component, OnInit } from '@angular/core'
import { FormControlDirective, FormGroupDirective } from '@angular/forms';

@Component({
    providers: [FormControlDirective, FormGroupDirective],
    selector: 'indEnrollment',
    templateUrl: 'ind-enrollment.html',
    styleUrls: ['ind-enrollment.scss']
    
})

export class IndEnrollmentComponent implements OnInit {
    

    constructor() {

    }

    ngOnInit(): void {
      
    }




}
